// Danish. Same keys as nb in ../i18n.ts (the type checks that).
import type { Key, Text } from '../i18n.ts';

export const da: Record<Key, Text> = {
  appName: 'Find tid',
  tagline: 'find dagen, der passer flest',
  privacy: 'Privatliv',
  sourceCode: 'Kildekode',
  heroTitle: 'Find tiden, der passer flest',
  heroLead: 'Lav en aftale, vælg mulige dage eller klokkeslæt, og del linket. Alle markerer, hvornår de kan – uden login.',
  newEvent: 'Ny aftale',
  yourEvents: 'Dine aftaler',
  yourEventsHint: 'Huskes kun på denne enhed. Linkene virker på alle enheder.',
  showAllEvents: 'Vis alle ({n})',
  findLink: 'Find dine aftaler fra en anden enhed',
  findTitle: 'Find dine aftaler',
  findLead: 'Skriv den e-mailadresse, du angav, da du oprettede eller svarede på en aftale. Vi sender en kode til den, og så bliver aftalerne tilføjet på denne enhed.',
  findEmail: 'E-mailadresse',
  findSend: 'Send kode',
  findSent: 'Hvis adressen er brugt på en aftale her, kommer der straks en e-mail med en kode. Koden gælder i 10 minutter.',
  findCode: 'Kode fra e-mailen',
  findShow: 'Vis mine aftaler',
  findLinkLead: 'Tryk på knappen for at tilføje aftalerne for din e-mailadresse på denne enhed. Linket virker én gang.',
  findAgain: 'Send ny kode',
  findOther: 'Brug en anden adresse',
  findAsked: 'Bad om en ny kode.',
  findFound: { one: 'Fandt {n} aftale. Den er tilføjet på denne enhed.', other: 'Fandt {n} aftaler. De er tilføjet på denne enhed.' },
  findNone: 'Fandt ingen aftaler med denne adresse.',
  openAdmin: 'Admin',
  openMine: 'Mine svar',
  open: 'Åbn',
  tagAdmin: 'Admin',
  tagAnswered: 'Svaret',
  forget: 'Glem på denne enhed',
  leave: 'Log ud',
  leaveQ: 'Log ud på denne enhed?',
  leaveTextAdmin: 'Admin-linket fjernes fra denne enhed, og aftalen forsvinder fra din liste her. Du skal bruge linket for at komme tilbage, så gem det først.',
  leaveTextMine: 'Dit personlige link fjernes fra denne enhed, og aftalen forsvinder fra din liste her. Du skal bruge linket for at ændre dine svar senere, så gem det først.',
  leaveEmail: 'Du kan også få linket tilbage med en kode til din e-mailadresse.',
  leftToast: 'Logget ud på denne enhed',
  step1: 'Vælg mulige dage',
  step1Text: 'Datoer, eller klokkeslæt på hver dag. Fjern weekender og helligdage med ét tryk.',
  step2: 'Del linket',
  step2Text: 'Ét link til alle. Hver deltager får sit eget link til at ændre sine svar.',
  step3: 'Se, hvad der passer',
  step3Text: 'De dage og tider, der passer flest, kommer øverst.',
  loading: 'Indlæser …',
  pageNotFound: 'Siden blev ikke fundet',
  toHome: 'Til forsiden',
  eventNotFound: 'Aftalen blev ikke fundet',
  eventNotFoundText: 'Den kan være slettet, eller linket er forkert. Aftaler slettes automatisk 30 dage efter den sidste dato.',
  retry: 'Prøv igen',
  reload: 'Genindlæs',
  newVersion: 'En ny version er klar.',
  changedMeanwhile: 'En anden har lige ændret aftalen.',
  back: 'Tilbage',
  cancel: 'Annuller',
  ok: 'OK',
  done: 'Færdig',
  save: 'Gem',
  saved: 'Gemt',
  delete: 'Slet',
  deleted: 'Slettet',
  copy: 'Kopiér',
  copied: 'Kopieret',
  share: 'Del',
  link: 'Link',
  more: 'Mere',
  yes: 'Ja',
  maybe: 'Måske',
  no: 'Nej',
  name: 'Navn',
  sum: 'Kan',
  you: 'dig',
  language: 'Sprog',

  editEvent: 'Redigér aftalen',
  aboutEvent: 'Om aftalen',
  eventName: 'Aftalens navn',
  eventNamePh: 'For eksempel »Julefrokost«',
  descriptionOptional: 'Beskrivelse (valgfrit)',
  locationOptional: 'Sted (valgfrit)',
  whatToFind: 'Hvad skal I finde?',
  'mode.dates': 'Dage',
  'mode.datesHint': 'Hvilke dage passer?',
  'mode.times': 'Klokkeslæt',
  'mode.timesHint': 'Hvilke tider passer, dag for dag?',
  fromHour: 'Fra kl.',
  toHour: 'Til kl.',
  slotLength: 'Felter på',
  meetingLength: 'Mødet varer',
  timeZone: 'Tidszone',
  timeZoneHint: 'Alle ser tiderne i denne tidszone.',
  possibleDays: 'Mulige dage',
  theme: 'Tema',
  'theme.auto': 'Automatisk',
  'theme.autoHint': 'Lyst eller mørkt, som enheden',
  'theme.light': 'Lyst',
  'theme.dark': 'Mørkt',
  'theme.hacker': 'Hacker',
  rangeHint: 'Træk fra én dag til en anden for at tage alle dagene imellem med, eller klik på den første og shift-klik på den sidste.',
  rangeHintTouch: 'Hold fingeren på en dag, og træk til en anden for at tage alle dagene imellem med.',
  possibleDaysHint: 'Tryk på de dage, der kan passe, eller vælg flere med knapperne. Knapperne ændrer kun udvalget – du kan stadig tilføje eller fjerne enkelte dage bagefter.',
  period2w: 'Næste 2 uger',
  period4w: 'Næste 4 uger',
  periodMonth: 'Hele {month}',
  periodHint: 'Vælger præcis disse dage (i stedet for dem, du har valgt)',
  moreMonths: 'Vis næste måned',
  selNone: 'Ingen',
  undo: 'Fortryd',
  redo: 'Annuller fortryd',
  removedDays: { one: 'Fjernede 1 dag', other: 'Fjernede {n} dage' },
  timesCleared: 'Tiderne er fjernet',
  weekdays: 'Hverdage',
  weekends: 'Weekender',
  holidays: 'Helligdage',
  weekdaysHint: 'Fjern de valgte hverdage (mandag–fredag), eller vælg dem alle i kalenderen',
  weekendsHint: 'Fjern de valgte lørdage og søndage, eller vælg dem alle i kalenderen',
  holidaysHint: 'Fjern de valgte helligdage, eller vælg alle helligdagene i kalenderen',
  weekdayHint: 'Fjern de valgte {day}e, eller vælg dem alle i kalenderen',
  toggleWeek: 'Vælg eller fjern uge {n}',
  weekShort: 'U',
  nDays: { one: '1 dag valgt', other: '{n} dage valgt' },
  nSlots: { one: '1 tidsfelt', other: '{n} tidsfelter' },
  nDaysNoTimes: { one: '1 dag uden tider', other: '{n} dage uden tider' },
  possibleTimes: 'Mulige tider',
  possibleTimesHint: 'Træk hen over felterne for at markere eller fjerne tider. Tryk på en dag øverst for flere valg.',
  possibleTimesHintTouch: 'Tryk på et felt for at markere eller fjerne det, eller hold fingeren på et felt og træk hen over flere. Tryk på en dag øverst for flere valg.',
  'preset.all': 'Hele dagen',
  'preset.work': 'Arbejdstid 9–17',
  'preset.evening': 'Aften 17–22',
  'preset.clear': 'Ingen tider',
  pickDaysFirst: 'Vælg dage i kalenderen først.',
  dayAll: 'Vælg hele dagen',
  dayClear: 'Fjern alle tider denne dag',
  dayCopy: 'Brug disse tider på alle dage',
  dayCopyHint: 'Dage, du tilføjer senere, får også disse tider',
  dayRemove: 'Fjern dagen',
  settings: 'Indstillinger',
  'set.maybe': 'Tillad »måske«',
  'set.maybeHint': 'Deltagerne kan svare »kan, hvis det skal være«.',
  'set.maybeCounts': '»Måske« tæller som, at de kan',
  'set.maybeCountsHint': 'Rangeringen tæller alle, der kan eller måske kan. Ellers tæller kun ja, og ved lige mange ja står den med flest »måske« først.',
  'set.openEdit': 'ændre og slette alles svar',
  'set.openEditHint': 'Ellers kun deres eget.',
  'set.hidden': 'se svarene',
  'set.hiddenHint': 'Hvem der har svaret hvad, og hvor mange. Ellers ser kun arrangørerne det, og hver deltager sit eget svar.',
  'set.closed': 'Lukket for nye svar',
  'set.closedHint': 'Ingen undtagen arrangørerne kan svare eller ændre noget.',
  'set.newNames': 'svare under et nyt navn',
  'set.newNamesHint': 'Ellers kan kun de navne, I har sat på listen, svare.',
  'set.claims': 'svare som et navn på listen',
  'set.claimsHint': 'Ved at trykke på deres navn med linket til aftalen. Ellers skal de have deres personlige link fra jer.',
  'set.rename': 'ændre deres navn',
  'set.renameHint': 'Ellers står navnet, som det først blev skrevet, eller som I skrev det på listen.',
  'set.decide': 'vælge, hvad det bliver',
  'set.decideHint': 'Vælge den endelige dag eller tid og fortryde valget. Aftalen forbliver åben: kun arrangørerne lukker den.',
  'set.details': 'ændre navn, sted og beskrivelse',
  'set.detailsHint': 'På aftalen. Det vises ikke, hvem der ændrede dem, men I kan altid ændre dem tilbage.',
  yourEmailOptional: 'Din e-mail (valgfrit)',
  adminEmailsOptional: 'Arrangørernes e-mail (valgfrit)',
  addDetails: 'Tilføj beskrivelse og sted',
  manyWeeks: 'Deltagerne skal igennem {n} uger med tider, én uge ad gangen på mobilen. Færre dage gør det hurtigere at svare.',
  emailOptional: 'E-mail (valgfrit)',
  addEmail: 'Tilføj e-mail',
  adminEmailHint: 'Gemmes med aftalen, så du kan finde aftalen igen på en anden enhed (vi sender dig en kode). Er I flere arrangører, kan I tilføje en e-mail hver. Kun dem med admin-linket kan se dem.',
  addEmailRow: 'Tilføj en e-mail mere',
  removeEmail: 'Fjern e-mailen',
  createEvent: 'Opret aftale',
  saveChanges: 'Gem ændringer',
  lostAnswers: {
    one: '1 svar gælder dage eller tider, der fjernes, og bliver slettet.',
    other: '{n} svar gælder dage eller tider, der fjernes, og bliver slettet.',
  },
  saveAnyway: 'Gem alligevel',

  createdTitle: 'Aftalen er klar!',
  createdText: 'Del linket til aftalen med dem, du vil invitere. Pas godt på admin-linket: med det ændrer du aftalen, og du kan dele det med andre arrangører.',
  savedNewTitle: 'Tak, {name}! Dine svar er gemt.',
  savedNewText: 'Dette er dit personlige link. Med det kan du ændre svarene senere fra enhver enhed.',
  savedNewHint: 'Gem linket: tilføj det som bogmærke, eller send det til dig selv. Del det ikke – den, der har linket, kan ændre dine svar.',
  yourLink: 'Dit personlige link',
  linkInvalid: 'Dette link virker ikke længere. Det kan være skiftet ud med et nyt, eller svaret er slettet. Du ser aftalen som gæst.',
  storedAdmin: 'Du er admin for denne aftale på denne enhed.',
  storedMine: 'Denne enhed har dit personlige link til denne aftale.',
  closedInfo: 'Aftalen er lukket for nye svar.',
  closedAdmin: 'Aftalen er lukket. Kun arrangørerne kan tilføje eller ændre svar.',
  metaDates: { one: '1 mulig dag', other: '{n} mulige dage' },
  metaTimes: 'Klokkeslæt · mødet varer {dur}',
  timesIn: 'Tider i {tz}',
  yourTz: '(du er i {tz})',
  metaHidden: 'Kun arrangørerne kan se svarene',
  metaOpenEdit: 'Alle kan ændre svarene',
  permsTitle: 'Deltagerne kan',
  metaListOnly: 'Kun navnene på listen kan svare',
  metaDecide: 'Alle kan vælge, hvad det bliver',
  editDetails: 'Ændr navn og sted',
  editDetailsHint: 'Alle med linket til aftalen ser ændringen.',
  detailsSaved: 'Ændringerne er gemt.',
  listOnlyInfo: 'Kun dem på listen kan svare, med det personlige link, de har fået fra arrangørerne.',
  listOnlyClaim: 'Kun navnene på listen kan svare.',
  nameFixed: 'Navnet kan ikke ændres i denne aftale.',
  youAreAdmin: 'Du er admin',
  adminHint: 'Du kan ændre aftalen og alle svarene.',
  addAnswers: 'Tilføj svar',
  personName: 'Navn',
  close: 'Luk',
  reopen: 'Åbn igen',
  hiName: 'Hej, {name}!',
  personalHint: 'Dette er dit personlige link. Brug det, når du vil ændre svarene.',
  editYourAnswers: 'Ændr dine svar',
  copyMyLink: 'Kopiér mit link',
  shareEvent: 'Del aftalen',
  addYourAnswers: 'Tilføj dine svar',
  shareTitle: 'Del aftalen',
  shareHint: 'Send dette link til alle, der skal være med.',
  eventLink: 'Link til aftalen',
  adminLinkTitle: 'Admin-linket',
  adminLinkHint: 'Del det med dem, der skal være arrangører sammen med dig. Alle, der har det, kan ændre aftalen og alle svarene.',
  qrTitle: 'QR-kode til aftalen',
  resultsTitle: 'Hvad passer bedst?',
  noAnswersYet: 'Ingen har svaret endnu.',
  noneAvailable: 'Ingen af mulighederne passer nogen endnu.',
  hiddenInfo: 'Svarene er skjult: kun arrangørerne kan se dem, og hvor mange der har svaret.',
  'tab.cal': 'Kalender',
  'tab.list': 'Liste',
  'tab.table': 'Tabel',
  'tab.grid': 'Gitter',
  legendFew: 'Få kan',
  legendMany: 'Mange kan',
  legendTop: 'Flest kan',
  tapForDetails: 'Tryk på en mulighed for at se, hvem der kan.',
  tapCellForDetails: 'Tryk på et felt for at se, hvem der kan.',
  nOfM: '{n} af {m} kan',
  decidedTitle: 'Aftalt',
  decidedTag: 'Valgt',
  decidedThis: 'Dette er valgt',
  decideThis: 'Vælg {when}',
  decideQ: 'Vælge {when}? Alle, der åbner aftalen, ser valget, og aftalen lukkes for nye svar.',
  decideOk: 'Vælg',
  decidedToast: 'Valgt. Del linket, så alle kan se det.',
  undecideQ: 'Fortryd valget? Aftalen forbliver lukket, indtil du åbner den igen.',
  decideQOpen: 'Vælge {when}? Alle, der åbner aftalen, ser valget.',
  undecideQOpen: 'Fortryd valget?',
  undoDecision: 'Fortryd valget',
  undecidedToast: 'Valget er fortrudt',
  addToCalendar: 'Føj til kalender',
  nMaybe: { one: '1 måske', other: '{n} måske' },
  nMaybeIncl: { one: 'inkl. 1 måske', other: 'inkl. {n} måske' },
  moreTied: { one: 'Vis 1 mere med lige så mange, der kan', other: 'Vis {n} mere med lige så mange, der kan' },
  showFewer: 'Vis færre',
  rankYesFirst: 'Rangeret efter flest ja. Ved lige mange står den med flest »måske« først.',
  rankMaybeCounts: 'Rangeret efter flest, der kan, »måske« medregnet. Ved lige mange står den med flest ja først.',
  canCome: 'Kan',
  ifNeedBe: 'Måske',
  cannot: 'Kan ikke',
  responses: 'Svar',
  hiddenPeople: 'Svarene er skjult. Du ser kun dit eget.',
  sumYes: 'Kan {n} af {m}',
  sumYesTime: 'Kan {dur}',
  maybeDur: 'måske {dur}',
  sumNoneDates: 'Kan ingen af dagene',
  sumNoneTimes: 'Kan ingen af tiderne',
  nOfTotal: '{n} af {m}',
  answeredOf: '{n} af {m} har svaret',
  notAnswered: 'Har ikke svaret endnu',
  noAnswer: 'Ikke svaret',
  youNotAnswered: 'Du har ikke svaret endnu.',
  addNames: 'Tilføj navne',
  addNamesTitle: 'Hvem er inviteret?',
  addNamesText: 'Ét navn pr. linje, eller indsæt en liste. Så kan du se, hvem der ikke har svaret endnu, og hver får sit eget link, som du kan sende til dem. Navnene vises for alle, der åbner aftalen, medmindre svarene er skjult.',
  addNamesPh: 'Mette\nLars\nSofie',
  addNamesOk: 'Tilføj',
  namesAdded: { one: 'Tilføjede 1 navn.', other: 'Tilføjede {n} navne.' },
  namesSkipped: { one: '1 navn var der i forvejen.', other: '{n} navne var der i forvejen.' },
  copyReminder: 'Kopiér påmindelse',
  reminderText: '{names}: husk at svare på »{name}«! {url}',
  claimQ: 'Er du en af disse?',
  claimHint: 'Tryk på dit navn, så gemmes dine svar der. Står du ikke på listen, skriver du bare dit navn.',
  claimWho: 'Hvem er du?',
  claimListHint: 'Kun navnene på listen kan svare. Skriv for at finde dit.',
  claimAdmin: 'Svarer du for en af disse?',
  claimAdminHint: 'Tryk på et navn for at lægge svarene der, eller skriv et nyt navn.',
  answerFor: 'Svar for {name}',
  removeName: 'Fjern {name}',
  removeNameQ: 'Fjerne {name} fra listen?',
  remove: 'Fjern',
  showAnswered: 'Vis som besvaret',
  draftNoteOwn: 'Gemmes som kladde: du står under »Har ikke svaret endnu«, og svarene tælles ikke med, før du gemmer med denne slået til.',
  draftNote: 'Gemmes som kladde: personen står under »Har ikke svaret endnu«, og svarene tælles ikke med, før de gemmes med denne slået til.',
  draftSaved: 'Kladden er gemt. Den tælles ikke med, før den gemmes som besvaret.',
  savedDraftTitle: 'Din kladde er gemt, {name}.',
  youHaveDraft: 'Du har en kladde, som ikke tælles med endnu.',
  claimNone: 'Ingen på listen hedder det, så det bliver et nyt navn.',
  claimMatches: { one: '1 navn på listen passer', other: '{n} navne på listen passer' },
  showAllNames: 'Vis alle ({n})',
  answerAs: 'Svar som {name}',
  copyPersonLink: 'Linket til {name}',
  deleteEntry: 'Slet svaret fra {name}',
  expiresNote: 'Aftalen slettes automatisk {date}.',
  adminMenu: 'Admin',
  newAdminLink: 'Nyt admin-link',
  newAdminLinkHint: 'Det gamle holder op med at virke',
  newAdminLinkQ: 'Lave et nyt admin-link? Det gamle holder op med at virke med det samme, for alle, der har det.',
  makeNewLink: 'Lav nyt link',
  newLinkDone: 'Nyt link',
  newAdminLinkDoneText: 'Dette er det nye admin-link. Det gamle virker ikke længere, så send dette til eventuelle andre arrangører.',
  deleteEvent: 'Slet aftalen',
  deleteEventHint: 'Sletter alt, også alle svarene',
  deleteEventQ: 'Slette aftalen og alle svarene? Det kan ikke fortrydes.',
  eventDeleted: 'Aftalen er slettet',
  meMenu: 'Dine svar',
  newMyLink: 'Nyt personligt link',
  newMyLinkHint: 'Det gamle holder op med at virke',
  newMyLinkQ: 'Lave et nyt personligt link? Det gamle holder op med at virke med det samme.',
  newMyLinkDoneText: 'Dette er dit nye personlige link. Det gamle virker ikke længere.',
  deleteMine: 'Slet mine svar',
  deleteMineQ: 'Slette dine svar?',
  deleteEntryQ: 'Slette svaret fra {name}?',
  personLinkTitle: 'Linket til {name}',
  personLinkText: 'Den, der har dette link, kan ændre svarene. Send det kun til den person, det gælder.',
  addedByAdminText: 'Svaret er tilføjet. Med dette link kan personen selv ændre svarene senere.',
  closedToast: 'Aftalen er lukket',
  reopenedToast: 'Aftalen er åbnet igen',

  editAnswersOf: 'Ændr svarene fra {name}',
  yourName: 'Dit navn',
  emailHint: 'Gemmes med svaret, så du kan finde aftalen igen på en anden enhed (vi sender dig en kode). Ingen andre kan se den.',
  commentOptional: 'Kommentar (valgfrit)',
  commentPh: 'For eksempel »Kan kun efter kl. 18«',
  whichDays: 'Hvilke dage passer?',
  whichTimes: 'Hvilke tider passer?',
  answerDatesHint: 'Tryk på de dage, du kan.',
  answerDatesHintMaybe: 'Tryk én gang for »ja«, to gange for »måske« og tre gange for at fjerne.',
  answerTimesHint: 'Træk hen over de tider, du kan. Træk fra et markeret felt for at fjerne. Tryk på en dag øverst for at svare for hele dagen.',
  answerTimesHintMaybe: 'Vælg »Kan« eller »Måske«, og træk hen over tiderne. Træk fra et markeret felt for at fjerne. Tryk på en dag øverst for at svare for hele dagen.',
  answerTimesHintTouch: 'Tryk på de tider, du kan, eller hold fingeren på et felt og træk hen over flere. Start på et markeret felt for at fjerne. Tryk på en dag øverst for at svare for hele dagen.',
  answerTimesHintTouchMaybe: 'Vælg »Kan« eller »Måske«, og tryk på tiderne, eller hold fingeren på et felt og træk hen over flere. Start på et markeret felt for at fjerne. Tryk på en dag øverst for at svare for hele dagen.',
  brush: 'Markér som',
  yesToAll: 'Ja til alle',
  clearAll: 'Nulstil',
  dayYes: 'Kan hele dagen',
  dayMaybe: 'Måske hele dagen',
  dayNone: 'Kan ikke denne dag',
  pickSumDates: 'Du kan {n} af {m} dage',
  pickSumTimes: 'Du kan {dur}',
  pickSumNone: 'Intet markeret endnu',
  discardQ: 'Kassér ændringerne?',
  discard: 'Kassér',

  weeks: 'Uger',
  weekN: 'Uge {n}',
  weekRange: 'Uge {a}–{b}',
  weekPair: 'Uge {a} og {b}',
  gridPaintLabel: 'Tider. Piletasterne flytter, mellemrum markerer.',
  gridViewLabel: 'Oversigt over tiderne',

  'err.network': 'Kunne ikke få kontakt med serveren. Tjek nettet, og prøv igen.',
  'err.rate': 'For mange forespørgsler. Vent lidt, og prøv igen.',
  'err.notFound': 'Aftalen blev ikke fundet.',
  'err.forbidden': 'Du har ikke lov til at gøre dette.',
  'err.listOnly': 'Kun navnene på listen kan svare. Vælg dit.',
  'err.rename': 'Navnet kan ikke ændres i denne aftale.',
  'err.decided': 'Det er ikke en af mulighederne.',
  'err.closed': 'Aftalen er lukket for nye svar.',
  'err.full': 'Aftalen har fået så mange svar, som den kan rumme.',
  'err.person': 'Svaret blev ikke fundet. Det kan være slettet.',
  'err.personName': 'Skriv dit navn.',
  'err.email': 'E-mailadressen ser ikke rigtig ud.',
  'err.emails': 'Højst 10 e-mailadresser.',
  'err.code': 'Koden er forkert eller udløbet.',
  'err.link': 'Linket er allerede brugt eller udløbet. Bed om en ny kode.',
  'err.wait.minute': 'Du har lige bedt om en kode. Vent et minut, før du beder om en ny.',
  'err.wait.hour': 'Du har bedt om flere koder. Prøv igen om en time.',
  'err.wait.day': 'Dagens grænse for koder er nået. Prøv igen i morgen.',
  'err.mail': 'Vi kan ikke sende e-mail lige nu. Prøv igen senere.',
  'err.name': 'Giv aftalen et navn.',
  'err.range': 'Ugyldige datoer.',
  'err.rangeLong': 'Der kan højst være ét år fra første til sidste dag.',
  'err.rangeLongTimes': 'Med klokkeslæt kan der højst være 62 dage fra første til sidste dag.',
  'err.hours': 'Vælg et gyldigt tidsrum.',
  'err.options': 'Vælg mindst én mulig dag eller tid.',
  'err.tooMany': 'For mange mulige tider (højst 2000). Vælg færre dage eller længere felter.',
  'err.server': 'Noget gik galt. Prøv igen.',
  'err.taken': 'Nogen har lige svaret under det navn. Vælg et andet, eller skriv dit navn.',
  'err.answered': 'Personen har lige svaret selv, så deres svar er bevaret.',
  'err.names': 'Skriv mindst ét navn.',
  'err.tooManyNames': 'Det bliver for mange. En aftale kan højst have 200 navne og svar tilsammen.',

  'holiday.newYear': 'Nytårsdag',
  'holiday.maundyThursday': 'Skærtorsdag',
  'holiday.goodFriday': 'Langfredag',
  'holiday.easter': 'Påskedag',
  'holiday.easterMonday': '2. påskedag',
  'holiday.mayDay': '1. maj',
  'holiday.constitutionDay': 'Norges nationaldag',
  'holiday.ascension': 'Kristi himmelfartsdag',
  'holiday.whitsun': 'Pinsedag',
  'holiday.whitMonday': '2. pinsedag',
  'holiday.christmas': 'Juledag',
  'holiday.boxingDay': '2. juledag',
  'holiday.christmasEve': 'Juleaften',
  'holiday.newYearsEve': 'Nytårsaften',
  'holiday.epiphany': 'Helligtrekongersdag',
  'holiday.nationalDaySe': 'Sveriges nationaldag',
  'holiday.midsummerEve': 'Midsommeraften',
  'holiday.midsummerDay': 'Midsommerdag',
  'holiday.allSaints': 'Allehelgensdag',
  'holiday.greatPrayerDay': 'Store bededag',
  holidayCal: 'Helligdage i kalenderen',
  holidayCalHint: 'Helligdagene får en prik, og knappen »Helligdage« vælger dem. Juleaften og nytårsaften er med, i Sverige også midsommeraften.',
  'holidayCal.no': 'Norge',
  'holidayCal.se': 'Sverige',
  'holidayCal.dk': 'Danmark',
  'holidayCal.none': 'Ingen',
};
